import React from 'react';
import {
  FaVideo,
  FaGavel,
  FaFacebook,
  FaImage,
  FaShareAlt,
  FaComments,
  FaFilm,
  FaMusic,
  FaNewspaper,
  FaBullhorn,
  FaSearch,
} from 'react-icons/fa';
import { IoFastFood } from 'react-icons/io5';
import PersonIcon from "../../../mainApp/images/PersonIcon";
import {
  Description,
  PersonNameStyle,
  NoPoster,
  Poster,
  StyledTilePerson,
  StyledPersonIcon,
  Wrapper,
  StyledNavLink,
  PersonRole,
  PosterWrapper,
  PremiumBadge,
  IconWrapper,
} from "./styled";
import Rolls from "../../../aiApp/components/Assets/reels.jpg";
import Meditation from "../../../aiApp/components/Assets/4.png";
import Lawyer from "../../../aiApp/components/Assets/lawyer.jpg";
import Songs from "../../../aiApp/components/Assets/2.png";
import FacebookPosts from "../../../aiApp/components/Assets/facebook.jpg";
import ImageCreator from "../../../aiApp/components/Assets/artist.png";
import socialMediaCopyWriter from "../../../aiApp/components/Assets/socialmedia.jpg";
import CasualAssistant from "../../../aiApp/components/Assets/assistant.jpg";
import VideoCreator from "../../../aiApp/components/Assets/filmmaker.jpg";
import Default from "../../../aiApp/components/Assets/stock_avatar.png";

const iconMap = {
  Rolls: FaVideo,
  Lawyer: FaGavel,
  FacebookPosts: FaFacebook,
  ImageCreator: FaImage,
  socialMediaCopyWriter: FaShareAlt,
  CasualAssistant: FaComments,
  VideoCreator: FaFilm,
  Songs: FaMusic,
  Articles: FaNewspaper,
  Advertisement: FaBullhorn,
  Search: FaSearch,
  Diet: IoFastFood,
};

const TilePerson = ({
  personRole,
  personName,
  personProfilePath,
  personId,
  address,
  isNew = false,
  isSoon = false,
  isOffice = true, // domyślnie isOffice jest true
  $isPremium = false,
}) => {
  const getPosterSource = () => {
    switch (personProfilePath) {
      case "Rolls":
        return Rolls;
      case "Meditation":
        return Meditation;
      case "Lawyer":
        return Lawyer;
      // case "Songs":
      //   return Rolls;
          case "FacebookPosts":
        return FacebookPosts;
           case "ImageCreator":
        return ImageCreator;
             case "socialMediaCopyWriter":
        return socialMediaCopyWriter;
                    case "CasualAssistant":
        return CasualAssistant;
        //  case "Advertisement":
        // return FacebookPosts;
        //      case "Articles":
        // return socialMediaCopyWriter;
        //      case "Search":
        // return CasualAssistant;
        //      case "Diet":
        // return CasualAssistant;
        //      case "Mentoring":
        // return Lawyer;
        //      case "Narrator":
        // return VideoCreator;
        //      case "Seo":
        // return ImageCreator;
            case "VideoCreator":
        return VideoCreator;
      default:
        return Default;
    }
  };

  const selectedPoster = getPosterSource();
  const IconComponent = iconMap[personProfilePath];
  
  return (
    <StyledNavLink to={address} isSoon={isSoon}>
      <Wrapper isSoon={isSoon}>
        <StyledTilePerson>
          <PosterWrapper>
            {!personProfilePath || personProfilePath === 'null' ? (
              <NoPoster>
                <StyledPersonIcon>
                  <PersonIcon width={"100%"} height={"100%"} />
                </StyledPersonIcon>
              </NoPoster>
            ) : isOffice ? (
              <>
                {IconComponent ? (
                  <IconWrapper data-premium={$isPremium}>
                    <IconComponent />
                  </IconWrapper>
                ) : (
                  <NoPoster>
                    <StyledPersonIcon>
                      <PersonIcon width={"100%"} height={"100%"} />
                    </StyledPersonIcon>
                  </NoPoster>
                )}
                {isNew && <PremiumBadge>NOWOŚĆ</PremiumBadge>}
                {isSoon && <PremiumBadge isSoon={isSoon}>WKRÓTCE</PremiumBadge>}
              </>
            ) : (
              <>
                <Poster 
                  src={selectedPoster} 
                  alt={`${personName} - ${personRole}`}
                  loading="lazy"
                />
                {isNew && <PremiumBadge>NOWOŚĆ</PremiumBadge>}
                {isSoon && <PremiumBadge isSoon={isSoon}>WKRÓTCE</PremiumBadge>}
              </>
            )}
          </PosterWrapper>
          <Description>
            <PersonNameStyle title={personName}>{personName}</PersonNameStyle>
            <PersonRole title={personRole}>{personRole}</PersonRole>
          </Description>
        </StyledTilePerson>
      </Wrapper>
    </StyledNavLink>
  );
};

export default React.memo(TilePerson);